import template from "./index.html";
import { EVENT_LOGOUT } from "../../../constants";

//terms
export function controller($scope, eventBus) {
	const ctrl = this;

	ctrl.handleClose = handleClose;
	ctrl.$onInit = onInit;
	ctrl.$onDestroy = handleClose;

	function onInit() {
		eventBus.register(EVENT_LOGOUT, () => { handleClose(); }, $scope);
	}

	function handleClose() {
		ctrl.modalInstance.close();
	}
}

export default angular
	.module("vesl.components.account-deletion", [])
	.component("accountDeletion", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<"
		}
	}).name;
